import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'environments/environment';
import { SupplierApiModel } from '../models/api/supplier-api-model.model';

@Injectable({
    providedIn: 'root'
})
export class SupplierService {
    private apiUrl = `${environment.apiEndPoint}/Supplier`;

    constructor(private http: HttpClient) { }

    getAll(): Observable<SupplierApiModel[]> {
        return this.http.get<SupplierApiModel[]>(this.apiUrl);
    }

    getById(id: number): Observable<SupplierApiModel> {
        return this.http.get<SupplierApiModel>(`${this.apiUrl}/${id}`);
    }

    add(item: SupplierApiModel): Observable<SupplierApiModel> {
        return this.http.post<SupplierApiModel>(this.apiUrl, item);
    }

    update(item: SupplierApiModel): Observable<SupplierApiModel> {
        return this.http.put<SupplierApiModel>(`${this.apiUrl}/${item.supplierId}`, item); // Assuming supplierId is the key property
    }

    delete(id: number): Observable<void> {
        return this.http.delete<void>(`${this.apiUrl}/${id}`);
    }
}